<ion-header>
	<ion-toolbar mode="md">
		<ion-title>{{ 'Crew Shift' | translate }}</ion-title>
		<ion-buttons slot="end" (click)="!requesting && dismiss()">
			<ion-button>
				<ion-icon slot="start" name="close-circle"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>
<ng-container *ngIf="requesting">
	<ion-progress-bar type="indeterminate"></ion-progress-bar>
</ng-container>
<ion-content>
	<ion-refresher
				   slot="fixed"
				   (ionRefresh)="!requesting && dismiss()"></ion-refresher>
	<ion-list>
		<ion-item-divider>
			<ion-searchbar
						   [cancelButtonText]="'Cancel' | translate"
						   mode="ios"
						   animated
						   [placeholder]="'Search...' | translate"
						   debounce="500"
						   (ionChange)="search($event)"
						   show-cancel-button="focus">
			</ion-searchbar>
		</ion-item-divider>
		<ng-container *ngFor="let user of users; let i = index">
			<ion-item-sliding #itemSliding>
				<ion-item
						  (click)="isSelectable(user) && user.selected = !user.selected">
					<app-avatar
								class="ion-margin-end"
								[class.selected]="isSelectable(user) && user.selected"
								[data]="user"
								slot="start"></app-avatar>
					<ion-label>
						{{ user.name }}
						<ng-container *ngIf="inAnotherShift(user.shift)">
							<p color="success">{{ 'in another Shift' | translate }}</p>
						</ng-container>
						<ng-container *ngIf="inProgress(user.shift)">
							<p>
								{{ 'Started at' | translate }}:
								{{ user.shift.started_at | chatDatetime }}
							</p>
							<p>
								<app-duration
											  class="color-primary"
											  startedAt="{{ user.shift.started_at }}">
								</app-duration>
							</p>
						</ng-container>

					</ion-label>
					<ion-note
							  class="ion-text-right"
							  slot="end"
							  fxLayout="column">

						<ng-container *ngIf="isLeader(user.shift)">
							<ng-container *ngIf="isMyLeader(user.shift)">
								<ion-text color="dark">{{ 'My Leader' | translate }}</ion-text>
							</ng-container>
							<ng-container *ngIf="amILeader(user.shift)">
								<ion-text color="dark">{{ 'You Leader' | translate }}</ion-text>
							</ng-container>
							<ng-container *ngIf="
												!isMyLeader(user.shift) &&
												!amILeader(user.shift)
											">
								<ion-text color="dark">{{ 'Leader' | translate }}</ion-text>
							</ng-container>
						</ng-container>

						<ng-container *ngIf="i == 1">
							<small fxLayoutAlign="end center">
								<ion-icon name="arrow-back"></ion-icon> {{ 'swipe left' | translate}}
							</small>
						</ng-container>
					</ion-note>
				</ion-item>
				<ion-item-options side="end">
					<ng-container *ngIf="user.shift && user.shift.leader_shift_id != myShift.leader_shift_id">
						<ion-item-option
										 color="medium"
										 class="ion-text-uppercase"
										 expandable
										 (click)="itemSliding.close(); requestBringIn(itemSliding, user)">
							<ion-icon name="git-compare"></ion-icon>&nbsp;{{ 'Bring In' | translate }}
						</ion-item-option>
					</ng-container>
					<ng-container *ngIf="getPhoneNumber(user)?.length && userAuthenticated?.id != user?.id">
						<ion-item-option
										 (click)="itemSliding.close(); callPhoneNumber(user)"
										 color="dark"
										 expandable>
							<ion-icon slot="start" name="call"></ion-icon> {{ 'Call' | translate}}
						</ion-item-option>
					</ng-container>
					<ng-container *ngIf="userAuthenticated?.id != user?.id">
						<ion-item-option
										 color="primary"
										 expandable
										 (click)="itemSliding.close(); messageUser(user)">
							<ion-icon slot="start" name="chatbox"></ion-icon> {{ 'Message' | translate}}
						</ion-item-option>
					</ng-container>
				</ion-item-options>
			</ion-item-sliding>
		</ng-container>
		<app-list-status
						 [requesting]="requesting"
						 [data]="users"></app-list-status>
	</ion-list>
	<ion-infinite-scroll threshold="10px" (ionInfinite)="pagination()" class="scroll-height">
	</ion-infinite-scroll>
</ion-content>
<ion-footer>
	<ion-toolbar>
		<ion-button mode="ios" class="ion-no-margin" expand="full" (click)="update()">
			{{ 'Update Crew Members' | translate }}
		</ion-button>
	</ion-toolbar>
</ion-footer>